import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box } from "@mui/material";
import { COLORS, PrimaryButton, SecondaryButton } from "./wtStyle";

// FR-12 — shown by the EXISTING Block button (UsersPage.jsx) only when the
// user being blocked has active work. "Block Anyway" is deliberately the
// secondary/plain button — FR-12 calls it "explicitly discouraged, for
// urgent/security cases" — while "Transfer First" is the recommended path.
export default function BlockWarningDialog({ open, onClose, userName, summary, onTransferFirst, onBlockAnyway }) {
  if (!summary) return null;

  const lines = [];
  if (summary.leadsCount > 0) lines.push(`${summary.leadsCount} lead(s) across ${summary.leadBuckets.join(", ")}`);
  if (summary.directReportsCount > 0) lines.push(`${summary.directReportsCount} direct report(s)`);
  if (summary.cpsSourcedCount > 0) lines.push(`${summary.cpsSourcedCount} CP(s) they're the sourcing manager for`);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ color: COLORS.orange, fontWeight: 700, fontSize: 18 }}>{userName} has active work</DialogTitle>
      <DialogContent>
        <Typography fontSize={13.5} sx={{ mb: 1 }}>
          Blocking now will leave this ownership behind:
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 3 }}>
          {lines.map((l, i) => (
            <li key={i}>
              <Typography fontSize={13.5}>{l}</Typography>
            </li>
          ))}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2, bgcolor: COLORS.sunken, borderTop: `1px solid ${COLORS.border}` }}>
        <SecondaryButton onClick={onBlockAnyway} sx={{ color: COLORS.red, borderColor: COLORS.red }}>
          Block Anyway
        </SecondaryButton>
        <PrimaryButton onClick={onTransferFirst}>Transfer First</PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}
